import { BaseDto } from '@/shared/dtos/base-dto';

export class grupo_centro extends BaseDto {
    public nombre !: string;
 } 
